import type { SVGProps } from 'react'
const SvgSyGpsFixed = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={3} />
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M12 2.4a.6.6 0 0 1 .6.6v2.025a7 7 0 0 1 6.375 6.376h.012L19 11.4h2a.6.6 0 0 1 0 1.2h-2.025a7 7 0 0 1-6.376 6.375v.01L12.6 19v2a.6.6 0 1 1-1.2 0v-2.025A7 7 0 0 1 5.025 12.6H3a.6.6 0 1 1 0-1.2h2.025A7 7 0 0 1 11.4 5.026V3a.6.6 0 0 1 .6-.6M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
			clipRule="evenodd"
		/>
	</svg>
)
export default SvgSyGpsFixed
